import React from 'react'
import { Link } from 'react-router-dom';
import { useState } from 'react';
import { Navbar, Nav } from 'react-bootstrap';
import { FaCaretDown } from "react-icons/fa";

export default function Navigation() {
    const [colorChange, setColorchange] = useState(false);
    const changeNavbarColor = () => {
        if (window.scrollY >= 80) {
            setColorchange(true);
        }
        else {
            setColorchange(false);
        }
    };
    window.addEventListener('scroll', changeNavbarColor);
    return (
        <div>
            <Navbar className={colorChange ? 'navbar colorChange' : 'navbar'} expand="lg" fixed='top'>
                <div className="logo-img ms-5">
                    <Link to='/'><img className='main-logo img-fluid' src="assets/images/amosta-logo.png" alt="" /></Link>
                </div>
                <Navbar.Toggle />
                <Navbar.Collapse>
                    <Nav className="ms-auto me-5 my-2 my-lg-0">
                        <div className="menu-main">
                            <ul className='my-auto'>
                                <li className='nav-links'><Link className='nav-links' to='/'>Home</Link></li>
                                <li className='nav-links'><Link className='nav-links' to='#'>About Us<FaCaretDown /></Link>
                                    <div className="normal-dropdown">
                                        <ul className='normal-dropdown-links'>
                                            <li className="sub-nav-link"><Link className='sub-nav-link' to='/whoweare'>Who We Are</Link></li>
                                            {/* <li className="sub-nav-link"><Link className='sub-nav-link' to='/ourteam'>Our Team</Link></li> */}
                                        </ul>
                                    </div>
                                </li>
                                <li className='nav-links'><Link className='nav-links' to='#'>Business Solutions<FaCaretDown /></Link>
                                    <div className="mega-dropdown">
                                        <ul className="mega-dropdown-links">
                                            <div className="row text-center">
                                                {/* <div className="col-sm-12 col-md-4">
                                                    <li className="sub-mega-nav-link"><Link className='sub-mega-nav-link' to='/hum-hai-seva-kendra'><img className='img-fluid nav-link-img' src="assets/images/Hum hai seva kendra.jpg" alt="" /><br /> Hum Hai Seva Kendra</Link></li>
                                                </div> */}
                                                {/* <div className="col-sm-12 col-md-4"><li className="sub-mega-nav-link"><Link className='sub-mega-nav-link' to='/identity-management-solutions'><img className='img-fluid nav-link-img' src="assets/images/Identity Management Solution.jpg" alt="" /><br />Identity Management Solutions</Link></li></div> */}
                                                <div className="col-sm-12 col-md-4"><li className="sub-mega-nav-link"><Link className='sub-mega-nav-link' to='/led-lights'><img className='img-fluid nav-link-img' src="assets/images/LED Lights.jpg" alt="" /><br />LED Lights Solutions</Link></li></div>
                                                <div className="col-sm-12 col-md-4"><li className="sub-mega-nav-link"><Link className='sub-mega-nav-link' to='/gst-robo'><img className='img-fluid nav-link-img' src="assets/images/gst-robo.png" alt="" /><br />GST Robo</Link></li>
                                                </div> 
                                                <div className="col-sm-12 col-md-4"><li className="sub-mega-nav-link"><Link className='sub-mega-nav-link' to='/verification'><img className='img-fluid nav-link-img' src="assets/images/Identity Management Solution.jpg" alt="" /><br/>Verification</Link></li>
                                                </div> 
                                            </div>
                                        </ul>
                                    </div>
                                </li>
                                {/* <li className='nav-links'><Link className='nav-links' to='#'>Project Management<FaCaretDown /></Link>
                                    <div className="normal-dropdown">
                                        <ul className='normal-dropdown-links'>
                                            <li className="sub-nav-link"><Link className='sub-nav-link' to='/software-development-solutions'>Software Development Solutions</Link></li>
                                            <li className="sub-nav-link"><Link className='sub-nav-link' to='/manpower-solutions'>Manpower Solutions</Link></li>
                                        </ul>
                                    </div>
                                </li> */}
                                <li className='nav-links'><Link className='nav-links' to='/about-acp'>Amosta Connect Program</Link></li>
                                <li className='nav-links'><Link className='nav-links' to='#'>Our Products<FaCaretDown /></Link>
                                    <div className="normal-dropdown">
                                        <ul className='normal-dropdown-links'>
                                            <li className="sub-nav-link"><Link className='sub-nav-link' to='/led-lights'>LED Lights</Link></li>
                                            <li className="sub-nav-link"><Link className='sub-nav-link' to='/detel-e-bike'>E-Bikes</Link></li>
                                            {/* <li className="sub-nav-link"><Link className='sub-nav-link' to='/mobile-accessories'>Mobile Accessories</Link></li> */}
                                        </ul>
                                    </div>
                                </li>
                                {/* <li className='nav-links'><Link className='nav-links' to='#'>Gallery<FaCaretDown /></Link>
                                    <div className="normal-dropdown">
                                        <ul className='normal-dropdown-links'>
                                            <li className="sub-nav-link"><Link className='sub-nav-link' to='/images'>Image Gallery</Link></li>
                                            <li className="sub-nav-link"><Link className='sub-nav-link' to='/videos'>Video Gallery</Link></li>
                                        </ul>
                                    </div>
                                </li> */}
                                {/* <li className='nav-links'><Link className='nav-links' to='/career'>Career</Link></li> */}
                                <li className='nav-links'><Link className='nav-links' to='/contact-us'>Contact Us</Link></li>
                            </ul>
                        </div>
                    </Nav>
                </Navbar.Collapse>
            </Navbar>
        </div>
    )
}
